import { PolymerElement, html } from "@polymer/polymer/polymer-element.js";
import "@polymer/polymer/lib/elements/dom-if.js";

import iconClose from "../../../../images/icons/icon_close.svg";
import googlePlayBadge from "../../../../images/google-play-logo.png";
import appStoreBadge from "../../../../images/app-store-logo.png";

import "./LimitReachedModal.style";

class LimitReachedModal extends PolymerElement {
  static get template() {
    return html`
      <style include="limit-reached-modal-style"></style>

      <template is="dom-if" if="[[isActive]]">
        <div class="limit-reached-modal__overlay" on-click="_closeWhenClickingBackdrop">
          <div
            class="limit-reached-modal__dialog"
            role="dialog"
            aria-modal="true"
            aria-labelledby="limit-reached-modal-title"
          >
            <button
              type="button"
              class="limit-reached-modal__close-btn"
              aria-label="Tutup"
              on-click="_close"
            >
              <img src="[[iconClose]]" alt="" aria-hidden="true" />
            </button>

            <div class="limit-reached-modal__copy">
              <template is="dom-if" if="[[aiGeneralCopytext.insufficient_popup_title]]">
                <h2 id="limit-reached-modal-title" class="limit-reached-modal__title">
                  [[aiGeneralCopytext.insufficient_popup_title]]
                </h2>
              </template>
              <template is="dom-if" if="[[aiGeneralCopytext.insufficient_popup_body]]">
                <p class="limit-reached-modal__description">
                  [[aiGeneralCopytext.insufficient_popup_body]]
                </p>
              </template>
            </div>

            <template is="dom-if" if="[[aiGeneralCopytext.insufficient_popup_image]]">
              <img
                class="limit-reached-modal__illustration"
                src="[[aiGeneralCopytext.insufficient_popup_image]]"
                alt="Ilustrasi aplikasi Alomedika"
              />
            </template>

            <template is="dom-if" if="[[aiGeneralCopytext.insufficient_popup_download]]">
              <p class="limit-reached-modal__cta-text">
                [[aiGeneralCopytext.insufficient_popup_download]]
              </p>
            </template>

            <div class="limit-reached-modal__store-links">
              <a
                href="https://alomedika.onelink.me/qZen/g6kj8jcr"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  class="limit-reached-modal__store-image"
                  src="[[googlePlayBadge]]"
                  alt="Google Play"
                />
              </a>
              <a
                href="https://alomedika.onelink.me/qZen/78l3cay5"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  class="limit-reached-modal__store-image"
                  src="[[appStoreBadge]]"
                  alt="App Store"
                />
              </a>
            </div>
          </div>
        </div>
      </template>
    `;
  }

  static get properties() {
    return {
      isActive: { type: Boolean, value: false },
      hasUserDismissed: { type: Boolean, value: false },
      isCreditsExhausted: { type: Boolean, value: false },
      aiGeneralCopytext: { type: Object, value: null },
      iconClose: { type: String, value: iconClose },
      googlePlayBadge: { type: String, value: googlePlayBadge },
      appStoreBadge: { type: String, value: appStoreBadge },
    };
  }

  static get observers() {
    return ["_syncFromCreditsExhausted(isCreditsExhausted)"];
  }

  // Open automatically when credits are exhausted on the chat screen unless the user dismissed the popup.
  _syncFromCreditsExhausted(isCreditsExhausted) {
    if (!isCreditsExhausted) {
      this.hasUserDismissed = false;
      return;
    }
    if (this.hasUserDismissed) return;
    this.isActive = true;
  }

  // Open the modal manually.
  open() {
    this.hasUserDismissed = false;
    this.isActive = true;
  }

  // Close the modal manually.
  _close() {
    this.isActive = false;
    if (this.isCreditsExhausted) {
      this.hasUserDismissed = true;
    }
  }

  // Close the modal when the user clicks the dark backdrop outside the dialog.
  _closeWhenClickingBackdrop(event) {
    if (event.target !== event.currentTarget) return;
    this._close();
  }
}

customElements.define("limit-reached-modal", LimitReachedModal);
